import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { useModal } from 'mui-modal-provider';
import { useNavigate } from 'react-router-dom';

import {
  getRefMyAcuvueId,
  removeRefMyAcuvueId,
  setRefMyAcuvueId,
} from '../../utils';
import { PROMO_CODE_UNDEFINED } from '../../constants/errors';
import { ENTER_PROMO_CODE } from '../../graphql';
import { useBind } from '../use-bind/use-bind';
import {
  ReferralModalLogin,
} from '../../components/business/app/referral-modal/referral-modal-login';
import { InternalLinks } from '../../constants';
import { EcpServices } from '../../components/business/app/ecp-locator';

export const useEnterPromoCode = () => {
  const [enterPromoCode] = useMutation(ENTER_PROMO_CODE);
  const enterPromoCodeBind = useBind(enterPromoCode);
  const { showModal } = useModal();
  const navigate = useNavigate();

  const registerPromoCode =  useCallback(async (refId: string | null, isLoggedIn: boolean) => {
    const promoCode = refId ?? getRefMyAcuvueId();

    if (promoCode && isLoggedIn) {
      try {
        if (enterPromoCodeBind?.current) {
          await enterPromoCodeBind.current({ variables: { promoCode } });

          removeRefMyAcuvueId();

          showModal(ReferralModalLogin, {
            onAction: () => navigate(`${InternalLinks.ecpLocator}?ecpService=${EcpServices.fit}`),
          });
        }
      } catch (error: any) {
        if (error?.message?.includes(PROMO_CODE_UNDEFINED)) {
          setRefMyAcuvueId(promoCode);
        } else {
          removeRefMyAcuvueId();
        }
      }
    }
  }, [enterPromoCodeBind]);

  return { registerPromoCode };
};
